module.exports = __webpack_public_path__ + "static/img/goods-100.87fe73d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s30/pop/goods-100.png
// module id = co2r
// module chunks = 2